export const enum ScheduleView {
  CALENDAR = "calendar",
  LIST = "list",
}

export const enum DisplayView {
  WEB = "web",
  MOBILE = "mobile",
}
